module.exports = __webpack_public_path__ + "img/XbHHppwIwhM.50de1dc0.jpg";